import ProductDetailsButton from 'gatsby-theme-husky/src/common/ProductDetailsButton/ProductDetailsButton';

import './ProductDetailsButtonOverride.scss';

export default ProductDetailsButton;
